import React, { useCallback, useEffect, useState } from 'react'
import { getDataFormInstance, postDataFormInstance } from '../api/processor'
import QuestionField from '../processor/components/ProcessInterstitial/Fields/field'

export const useRequesterQuestions = ({ formId, workflowType }) => {
  const [questions, setQuestions] = useState(null)
  const [values, setValues] = useState({})

  const initiateQuestions = useCallback(async () => {
    try {
      const res = await getDataFormInstance(formId)
      const fieldPermissions = res.data?.form?.field_permissions
      const allFields = res.data?.form?.html_flatten_form_fields
      const valuesResults = res.data?.form?.values
      const results = []
      if (allFields)
        Object.keys(allFields).map((key) => {
          if (fieldPermissions[key].buyer?.includes('update')) results.push(allFields[key])
        })
      setQuestions(results)
      setValues(valuesResults)
    } catch (error) {
      console.log(error)
    }
  }, [formId])

  useEffect(() => {
    if (workflowType === 'automated' && !!formId) {
      initiateQuestions()
    }
  }, [initiateQuestions])

  return { questions, values, setValues }
}

const RequesterQuestions = ({ questions, formId, onSubmit, values, setValues }) => {
  const handleSaveValues = async (e) => {
    e.preventDefault()
    onSubmit()
    try {
      const formData = new FormData()
      formData.append('form[updates]', JSON.stringify(values))
      const res = await postDataFormInstance(formId, formData)
    } catch (error) {}
  }

  return (
    <form onSubmit={handleSaveValues} className="dome-d-flex dome-full-width dome-flex-column dome-gap24">
      <div className="dome-d-flex dome-flex-column dome-gap12">
        <span className="dome-h3 dome-color-dark-grey">requester fields</span>
        <span className="dome-p1 dome-text-w300 dome-color-darkest-grey">
          Please fill out this required information before continuing to payment.
        </span>
      </div>
      <div style={{ gap: 8 }} className="payment-questions dome-d-flex dome-flex-column">
        {questions?.map((field) => {
          const type = field.form_field?.type
          if (type === 'select' || type === 'options')
            return (
              <div key={field.id} className="dome-d-flex dome-flex-column">
                <label style={{ margin: 0 }} className="dome-p2 dome-color-med-grey">
                  {field.question_label}*
                </label>
                <QuestionField
                  key={field.id}
                  id={field.id}
                  value={values[field.id]}
                  options={field.options}
                  field={field.form_field}
                  className="dome-full-width"
                  onChange={(e) => {
                    setValues((pre) => {
                      return {
                        ...pre,
                        [field.id]: e[field.id],
                      }
                    })
                  }}
                />
              </div>
            )
          return (
            <div key={field.id} className="auto-questionnaire-input-field">
              <div className="dome-d-flex dome-flex-column">
                <label style={{ margin: 0 }} className="dome-p2 dome-color-med-grey">
                  {field.question_label}*
                </label>
                <div className="dome-d-flex input-field-container">
                  <QuestionField
                    key={field.id}
                    id={field.id}
                    value={values[field.id]}
                    options={field.options}
                    field={field.form_field}
                    className="dome-full-width"
                    onChange={(e) => {
                      setValues((pre) => {
                        return {
                          ...pre,
                          [field.id]: e[field.id],
                        }
                      })
                    }}
                  />
                </div>
              </div>
            </div>
          )
        })}
      </div>
      <div className="dome-d-flex dome-full-width dome-justify-end">
        <button type="submit" className="dome-btn dome-btn-base dome-btn-dark-green">
          next
        </button>
      </div>
    </form>
  )
}
export default RequesterQuestions
